import { request, RespError, handleFormatRes } from '../../utils';
import { EXCHANGE_PRIZE } from '../../config/url';
/**
 * 订单号生成类型
 */
export var ExchangePrizeType;
(function (ExchangePrizeType) {
    /** 每天单号相同 */
    ExchangePrizeType[ExchangePrizeType["day"] = 1] = "day";
    /** 每秒单号相同 */
    ExchangePrizeType[ExchangePrizeType["second"] = 2] = "second";
    /** 每微秒单号相同 */
    ExchangePrizeType[ExchangePrizeType["microsecond"] = 3] = "microsecond";
})(ExchangePrizeType || (ExchangePrizeType = {}));
;
// 需要转成 int 型的 key 数组
const needParseIntKey = [];
// 需要转成 date 型的 key 数组
const needParseDateKey = [];
/**
 * 奖品兑换接口
 *
 * 通过获取的资格，调用兑换奖品接口，触发奖品派发
 *
 * 接口地址：`/app/promotion/prom_exchange_prize.cgi`
 *
 * @param qualId 查询指定id的资格信息，不需要转换
 * @param actListid 商品发放活动id
 * @param prizeNo 兑换的商品编号，不需要转换
 * @param type 单号生成类型：1-每天单号相同，2-每秒单号相同，3-每微秒单号相同
 * @returns
 */
export async function exchangePrize({ qualId, actListid, prizeNo, type = ExchangePrizeType.second, isAsync = false, }) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            qual_id: qualId,
            act_listid: actListid,
            prize_no: prizeNo,
            type,
            async: +isAsync,
        };
        // 接口请求
        const result = await request.get(EXCHANGE_PRIZE, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({
                    result,
                    needParseIntKey,
                    needParseDateKey,
                    transformer: (res) => {
                        const exchangeListId = res.listId;
                        delete res.listId;
                        return Object.assign(Object.assign({}, res), { exchangeListId });
                    },
                });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
